import React from 'react';
import styles from "./RightBar.module.css"

const RightBar = () => {
  return (
    <div className={styles.RightBar}>RightBar</div>
  )
}

export default RightBar